// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { isPristine } from 'redux-form'
import { loadingToggler } from 'redux/modules/loading'
import { AFS_GRID_RESULTS } from 'redux/modules/interferenceAnalysis/constants'
import { getAnalysisResults } from 'redux/modules/interferenceAnalysis'
import { postUpdatePolarizations } from 'helpers/api'
import { errorErrorsList } from 'redux/modules/notifications'

import {
  changedFieldNames,
  makeAFSPathPolarizationUpdateDTO,
} from './helpers'

import {
  success,
  warning,
} from 'react-notification-system-redux'

// NOTE - this behaves similar to a regular redux-form submit handler but
// it in fact is not. This is so that we can track only fields that were
// touched. redux-form sets all fields to touched onSubmit.
// See https://github.com/erikras/redux-form/issues/2019 for more information.

const handleAFSGridSave = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { form } = getState()

      // require form changes for submit
      if (isPristine(AFS_GRID_RESULTS)({ form })) {
        return dispatch(warning({
          autoDismiss: 3,
          message: 'You must select polarizations to update before saving.',
        }))
      }

      const {
        fields,
        values,
      } = form[AFS_GRID_RESULTS]

      // make an array of strings which point to the values which were changed.
      // these strings describe the path id and channel index which correspond
      // to the changed values.
      const updatedFieldNames = changedFieldNames(fields)

      // then grab those values from within the form's values object
      // and prepare those for the API with a unique structure.
      const afsPathPolarizationUpdateDTO = makeAFSPathPolarizationUpdateDTO(updatedFieldNames, values)

      try {
        // post the changes
        await postUpdatePolarizations(afsPathPolarizationUpdateDTO)

        // update what we have in redux-form and in interferenceAnalysis redux state
        // to reflect the polarization changes we've just made and update any analysis
        // values which are now changed because of the new polarization configuration.
        await dispatch(getAnalysisResults())

        dispatch(success({
          autoDismiss: 3,
          message: 'Updated path polarizations.',
        }))
      } catch (err) {
        console.warn(err)
        dispatch(errorErrorsList(err))
      }
    })
  )
)

export default handleAFSGridSave
